import { z } from 'zod';
const getFieldIdSchema = (args) => z
    .string()
    .describe([
    args.additionalDescription,
    '"fieldId" must come from the previously searched Fields; otherwise, it will throw an error',
]
    .filter(Boolean)
    .join(' '));
export { getFieldIdSchema };
//# sourceMappingURL=fieldId.js.map